<template>

  <panel-navigation>
      <admin-dashboard v-if="me && me.company_type == 'admin'" />
      <agency-dashboard v-if="me && me.company_type == 'agency'" />
      <business-dashboard v-if="me && (me.company_type == 'business' || me.company_type == 'location') && me.isDiy == 0" />
      <diy-new-dashboard v-if="me && (me.company_type == 'business' || me.company_type == 'location') && me.isDiy == 1" />
  </panel-navigation>

</template>

<script>
    import { mapState } from 'vuex'
    import AdminDashboard from '@/views/panel/Dashboard/Admin.vue'
    import AgencyDashboard from '@/views/panel/Dashboard/Agency.vue'
    import BusinessDashboard from '@/views/panel/Dashboard/Business.vue'
    import PanelNavigation from '@/components/PanelNavigation.vue'
    import DiyNewDashboard from '@/views/panel/Call/DiyNewDashboard.vue'

    export default {
        metaInfo () {
            return {
                title: "Dashboard | " + this.$appName
            }
        },
        components: {
            PanelNavigation,
            AdminDashboard,
            AgencyDashboard,
            BusinessDashboard,
            DiyNewDashboard
        },
        computed: {
            ...mapState({
                me: state => state.me.me
            })
        },
        methods: {
            isOnlyAi() {
                if (this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.status == 0)
                    return true;

                return false;
            },

            async refetchMe() {
                if (!this.me)
                    await this.$store.dispatch('me/fetch')

                // if (this.isOnlyAi() && (this.me.company_type == 'business' || this.me.company_type == 'location'))
                //     this.$router.push("/ai-agent");
            },
        },

        created() {
            this.refetchMe();
        }
    }
</script>

<style type="text/css">
    .theme--light.v-sheet--outlined {
        border: thin solid rgba(0, 0, 0, 0.12);
    }
</style>